// Automatic scan assignment monitor and Scan threshold revisions.
import {
  ScanAssignmentDecisionFilters,
  ScanAssignmentDecisionsResponse,
  ScanAssignmentOverviewResponse,
  ScanAssignmentSource,
  ScanThresholdConfiguration,
  ScanThresholdPreviewRequest,
  ScanThresholdPreviewResponse,
  ScanThresholdSaveRequest,
} from '../../types/scanAssignment';
import { forgeRequest } from '../forgeRequest';
import { SCAN_ASSIGNMENTS_API_URL, SCAN_THRESHOLDS_API_URL } from './endpoints';

export async function fetchScanAssignmentOverview(
  token: string,
  chainId: number,
  days: number,
  source: ScanAssignmentSource | null
): Promise<ScanAssignmentOverviewResponse> {
  const params = new URLSearchParams({ chain_id: String(chainId), days: String(days) });
  if (source) params.set('source', source);
  return forgeRequest<ScanAssignmentOverviewResponse>(
    token,
    `${SCAN_ASSIGNMENTS_API_URL}/overview?${params.toString()}`,
    'Error fetching scan assignment overview'
  );
}

export async function fetchScanAssignmentDecisions(
  token: string,
  filters: ScanAssignmentDecisionFilters
): Promise<ScanAssignmentDecisionsResponse> {
  const params = new URLSearchParams({
    chain_id: String(filters.chainId),
    days: String(filters.days),
    skip: String(filters.skip),
    limit: String(filters.limit),
  });
  if (filters.source) params.set('source', filters.source);
  if (filters.outcome) params.set('outcome', filters.outcome);
  if (filters.reason) params.set('reason', filters.reason);
  return forgeRequest<ScanAssignmentDecisionsResponse>(
    token,
    `${SCAN_ASSIGNMENTS_API_URL}/decisions?${params.toString()}`,
    'Error fetching scan assignment decisions'
  );
}

export async function retryScanAssignment(token: string, workId: string): Promise<void> {
  await forgeRequest<{ status: string }>(
    token,
    `${SCAN_ASSIGNMENTS_API_URL}/${encodeURIComponent(workId)}/retry`,
    'Error retrying scan assignment',
    { method: 'POST' }
  );
}

export async function fetchScanThresholdConfiguration(
  token: string
): Promise<ScanThresholdConfiguration> {
  return forgeRequest<ScanThresholdConfiguration>(
    token,
    SCAN_THRESHOLDS_API_URL,
    'Error fetching scan thresholds'
  );
}

export async function saveScanThresholds(
  token: string,
  request: ScanThresholdSaveRequest
): Promise<ScanThresholdConfiguration> {
  return forgeRequest<ScanThresholdConfiguration>(
    token,
    SCAN_THRESHOLDS_API_URL,
    'Error saving scan thresholds',
    { method: 'POST', body: request }
  );
}

export async function previewScanThresholds(
  token: string,
  request: ScanThresholdPreviewRequest
): Promise<ScanThresholdPreviewResponse> {
  return forgeRequest<ScanThresholdPreviewResponse>(
    token,
    `${SCAN_THRESHOLDS_API_URL}/preview`,
    'Error previewing scan thresholds',
    { method: 'POST', body: request }
  );
}
